import React from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import {withFirebase} from "../components/Firebase";
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Container from '@material-ui/core/Container';

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}));

function ForgotPassword(props) {

    const classes = useStyles();

    return (
        <Container component="main" maxWidth="xs">
            {
                sessionStorage.getItem("userLoggedIn") === "true" ? window.location.href = '/student/home' : <></>
            }
            <CssBaseline />
            <div className={classes.paper}>
                <Avatar className={classes.avatar}>
                    <LockOutlinedIcon />
                </Avatar>
                <Typography component="h1" variant="h5">
                    Reset password
                </Typography>
                <form className={classes.form} noValidate>
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        id="email"
                        label="Email Address"
                        name="email"
                        autoComplete="email"
                        autoFocus
                    />
                    <Button
                        type="button"
                        fullWidth
                        variant="contained"
                        color="primary"
                        className={classes.submit}
                        onClick={()=> {
                            function handleForgotPassword() {
                                let email = document.getElementById('email').value
                                props.firebase.doPasswordReset(email)
                                    .then(() => alert("Password reset sent - please check your inbox"))
                                    .then(() => props.history.push("/student/signin"))
                                    .catch((error) => { alert("Oops! An error occured! " + error.message) })
                            }
                            handleForgotPassword()}}
                    >
                        Reset Password
                    </Button>
                    <Grid container>
                        <Grid item xs>
                            <Link href="/student/signin" variant="body2">
                                {"Remembered password? Sign In"}
                            </Link>
                        </Grid>
                        {/*<Grid item>*/}
                        {/*    <Link href='/student/signup' variant="body2">*/}
                        {/*        {"Don't have an account? Sign Up"}*/}
                        {/*    </Link>*/}
                        {/*</Grid>*/}
                    </Grid>
                </form>
            </div>
        </Container>
    );
}

export default withFirebase(ForgotPassword);
